import EventBus from "../../../../src/app/core/eventbus/EventBus";
import ObjectUtil from "../../utils/ObjectUtil";

import {
    SET_IS_EMULATOR_LOADED,
    SET_AUTHENTICATION_STATUS,
    SET_ACCU_CUSTOMIZATIONS,
    SET_INIT_CUSTOMIZATIONS_DONE,
    SET_TRANSLATIONS,
    SET_SITE_CONTACT_INFO,
    SET_SITE_CONTACT_INFO_LANG_CODE
} from "./sharedActionTypes";

// years * days * hours * minutes * seconds * milliseconds
// 10 * 365 * 24 * 60 * 60 * 1000
const TEN_YEARS_IN_MILLISECONDS = 315360000000;

export const getCookie = (cookieKey) => {
    let cookieValue = document.cookie.split("; ").find((row) => row.startsWith(`${cookieKey}=`));

    if (cookieValue) {
        cookieValue = cookieValue.split("=")[1];
    }

    return cookieValue;
};

/* 
   Save cookies;  omit 'expire' attribute  if you want cookie to expire at end of session
*/
export const saveCookie = (name, value, path, domain, inputExpire, expireDays) => {
    const currentDate = new Date();
    const date = new Date();
    if (expireDays) {
        date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
    }
    const expire = expireDays
        ? date.toUTCString()
        : new Date(currentDate.getTime() + TEN_YEARS_IN_MILLISECONDS).toUTCString();
    document.cookie =
        name +
        "=" +
        value +
        (path ? ";path=" + path : "") +
        (domain ? ";domain=" + domain : "") +
        (inputExpire ? ";expires=" + expire : "");
};

export const deleteCookie = (name, path, domain) => {
    if (getCookie(name)) {
        document.cookie =
            name +
            "=" +
            (path ? ";path=" + path : "") +
            (domain ? ";domain=" + domain : "") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
};

/**
 * Write cookie for locale
 * expire - default to "", or session
 * @param {} localeCode
 */
export const setAppLocales = (localeCode) => {
    saveCookie("locale=", localeCode, "", "/");
};

// eventBus previously expected "this" as a primary argument, and "payload" as secondary argument
// instead of passing the application/components state/props to GA, we can pass passload 2x as ...data
export const dispatchEventBus = (type, ...data) => {
    const eventBus = new EventBus(window, document);
    if (ObjectUtil.isUndefinedOrNull(type)) {
        console.warn("please check the event type");
    }

    return () => {
        eventBus.dispatch(type, ...data);
    };
};

export const setIsEmulatorLoaded = (payload) => {
    return {
        type: SET_IS_EMULATOR_LOADED,
        payload
    };
};

/**
 * On account plan switch, update accu code cookies, omit 'expire' attribute so cookie expires at end of session
 *
 * @param {*} newAccuCode
 */
export const updateAccuCookie = (newAccuCode) => {
    deleteCookie("accu", "/");
    saveCookie("accu", newAccuCode, "/");

    deleteCookie("accu", "/participant");
    saveCookie("accu", newAccuCode, "/participant");

    deleteCookie("clientAccu", "/");
    saveCookie("clientAccu", newAccuCode, "/");

    deleteCookie("clientAccu", "/participant");
    saveCookie("clientAccu", newAccuCode, "/participant");
};

export const setAuthStatus = (authenticationStatus) => {
    return {
        type: SET_AUTHENTICATION_STATUS,
        payload: authenticationStatus
    };
};

export const setAccuCustomizations = (payload) => {
    sessionStorage.setItem("accuFaviconPng", payload.faviconPng);

    return {
        type: SET_ACCU_CUSTOMIZATIONS,
        payload
    };
};

/** Set initializeCustomizationsDone to true after authentication service and customization services called. */
export const setInitCustomizationsDone = () => {
    return {
        type: SET_INIT_CUSTOMIZATIONS_DONE
    };
};

export const setTranslations = (translations) => {
    return {
        type: SET_TRANSLATIONS,
        payload: translations
    };
};

export const setSiteContactInfo = (payload) => {
    return {
        type: SET_SITE_CONTACT_INFO,
        payload
    };
};

export const setLanguageCode = (langCode) => {
    return {
        type: SET_SITE_CONTACT_INFO_LANG_CODE,
        payload: { langCode }
    };
};
